import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { useTranslation } from "react-i18next"
import { DataResponse, UpsertShopifyIntegration } from "schema"
import { toast } from "sonner"
import { z } from "zod"
import { shopifyIntegrationQuery } from "../../lib/shopify/shopifyIntegrationQuery"

type Response = DataResponse<z.infer<typeof UpsertShopifyIntegration>>

export function useCreateShopifyIntegrationConfigurationMutation() {
  const queryClient = useQueryClient()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (data: z.infer<typeof UpsertShopifyIntegration>) => {
      const response = await axios.post<Response>(`/integrations/shopify`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: shopifyIntegrationQuery().queryKey })
      toast.success(t("settings.integrations.shopify.authModal.form.success"))
    },
  })
}
